export class BulkUpdateTeamConstants {
    static REJECT_AUTHORISE_FORM_CONTROL = "bulkUpdateTeamForm";
    static TITLE_LABEL = "Bulk reassign team member";
    static CONTINUE_BTN_LABEL = "Reassing User";
    static CANCEL_BTN_LABEL = "Cancel";
    static TEAM_ROLE_FORM_CONTROL_NAME = "teamRole";
    static CURRENT_ASSIGNED_USER_FORM_CONTROL_NAME = "currentAssignedUserformControlName";
    static NEW_ASSIGNED_USER_CONTROL_NAME = "newAssignedUserformControlName";
    static NO_ROLE_SELECTED = "No team role selected";
    static FORM_VALIDATION_MESSAGE = "Invalid Form, Required Fields Missing";
}
